export const stickyAddToCartListener = () => {
    // let productOptionsLoaded = false;
    // const comebackToConfigurationButton = document.querySelector(
    //     '.js-sticky-add-to-cart-text-comeback'
    // );
    // const addToCartButton = document.querySelector(
    //     '.js-sticky-add-to-cart-text-add'
    // );

    // window.addEventListener('remoteContent.#product-options.loaded', () => {
    //     productOptionsLoaded = true;

    //     comebackToConfigurationButton?.classList.add('d-none');
    //     addToCartButton?.classList.remove('d-none');
    // });

    const stickyAddToCartElements = [...document.querySelectorAll('.js-sticky-add-to-cart')].filter(
        (el) => !el.dataset.stickyAddToCartInitialized
    );

    stickyAddToCartElements.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            const scrollToElement = document.querySelector('.js-product-add-to-cart-scroll-to');

            console.log({ scrollToElement });

            scrollToElement?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });

            // if (!productOptionsLoaded) {
            //     const scrollToElement = document.querySelector(
            //         '.js-product-add-to-cart-scroll-to'
            //     );

            //     scrollToElement?.scrollIntoView({
            //         behavior: 'smooth',
            //         block: 'end',
            //         inline: 'nearest',
            //     });
            // } else {
            //     const productForm = document.querySelector('#add-to-cart-form');

            //     if (productForm?.reportValidity()) {
            //         productForm?.dispatchEvent(
            //             new Event('submit', { bubbles: true, cancelable: true })
            //         );
            //     }
            // }
        });

        el.dataset.stickyAddToCartInitialized = true;
    });
};
